import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ActionButton } from '@rivethealth/data/buttons';
import { Node } from '@rivethealth/data/options';
import { getTooltipFromNode } from './util';

@Component({
  selector: 'option-select-node',
  templateUrl: './option-select-node.component.html',
  styleUrls: ['./option-select-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionSelectNodeComponent {
  @Input()
  public node: Node;

  @Input()
  public disabled: boolean = false;

  @Input()
  public multiSelect: boolean = false;

  @Input()
  public atMinSelected: boolean = false;

  @Input()
  readonly draggable: boolean = false;

  @Input()
  public pinned: boolean = false;

  @Input()
  readonly showAvatars: boolean = false;

  @Input()
  all = false;

  @Input('actionButton')
  actionButton: ActionButton;

  @Input()
  displayId: boolean = false;

  @ViewChild('optionNode') nodeElement: ElementRef | null;
  placeholderWidth: number;

  @Output()
  dragWidth: EventEmitter<number> = new EventEmitter();

  public pinThis(event: MouseEvent) {
    event.stopPropagation();
    this.pinned = !this.pinned;
    if (this.pinned) {
      this.isPinned.emit();
    } else {
      this.isUnpinned.emit();
    }
  }

  public get tooltip(): string {
    return this.node.toolTip
      ? this.node.toolTip
      : this.node.subtitle
        ? `${this.node.title} - ${this.node.subtitle}`
        : this.node.title;
  }

  public selectedChanged(selected: boolean) {
    if (!this.disabled && !this.node.disabled) {
      if (selected) {
        this.selected.emit();
      } else {
        this.unselected.emit();
      }
    }
  }

  ngAfterViewInit() {
    this.placeholderWidth = this.nodeElement?.nativeElement.clientWidth;
    this.dragWidth.emit(this.placeholderWidth);
  }

  @Output() selected = new EventEmitter<void>();
  @Output() unselected = new EventEmitter<void>();
  @Output() isPinned = new EventEmitter<void>();
  @Output() isUnpinned = new EventEmitter<void>();

  getTooltipFromNode = getTooltipFromNode;
}
